import { EventBus } from '@primeuix/utils/eventbus';

var OverlayEventBus = EventBus();

export { OverlayEventBus as default };
//# sourceMappingURL=index.mjs.map
